import React, { useEffect, useState } from "react";
import { Collapse, Divider, message, Modal, Row } from "antd";
import { ICharacteristicsContext } from "../../context/CharacteristicsContext/types";
import { CharacteristicsContext } from "../../context/CharacteristicsContext/CharacteristicsContext";
import "./CharacteristicsContainer.less";
import { CharacteristicsTable } from "../../features/CharacteristicsTable/CharacteristicsTable";
import { ReactComponent as CharacteristicIconOpen } from "../../../../img/characteristic_icons/characteristicIconOpen.svg";
import { ReactComponent as CharacteristicIconClose } from "../../../../img/characteristic_icons/characteristicIconClose.svg";
import { TableDataCharacteristic } from "../../features/CharacteristicsTable/CharacteristicsTableTypes";
import { Characteristic } from "../../../../lib/types/Offer";
import { FieldsError } from "./utils/useCharacteristicsInitialisationType";
import { useAppDispatch, useAppSelector } from "../../../..";
import { characteristicsActions } from "../../store/slice/characteristicsSlice";

interface IProps {
  objectTypeId?: number;
  mode?: "create" | "edit" | "view" | "add" | "close";
  isInheritableObject?: boolean;
  isSelectedObjectId?: boolean;
  title?: string;
  tableData: TableDataCharacteristic[];
  setTableData: React.Dispatch<React.SetStateAction<TableDataCharacteristic[]>>;
  dataSaved?: Characteristic[];
  valuesTitle?: string;
  fromDateCharacteristic?: string | null;
  messageWarningNotFromDate?: string;
  newObjectChars?: Characteristic[];
  isNewObjectChars?: boolean;
  isDefaultDisabled?: boolean;
  disabledValidation?: boolean;
  fieldsError?: FieldsError;
  charIcoNotVisible?: boolean;
  isChildCharacteristic?: boolean;
  isDefaultOpen?: boolean;
}

export const CharacteristicsContainer = ({
  objectTypeId,
  mode,
  title,
  isInheritableObject,
  // Проверка, что у нас наследуемый объект по которому не известен objectTypeId (значит список объектов будет залочен на единственном objectTypeId)
  // Если есть isSelectedObjectId, то objectTypeId, должен отсутствовать
  isSelectedObjectId,
  tableData,
  setTableData,
  dataSaved,
  valuesTitle,
  fromDateCharacteristic,
  messageWarningNotFromDate,
  newObjectChars,
  isNewObjectChars,
  isDefaultDisabled,
  disabledValidation,
  fieldsError,
  charIcoNotVisible,
  isChildCharacteristic,
  isDefaultOpen = false,
}: IProps) => {
  const contextValue: ICharacteristicsContext = {};
  const dispatch = useAppDispatch();

  const { isUpdateParams } = useAppSelector((state) => state.characteristics);

  const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(isDefaultOpen);
  const [savedCharTableForModeView, setSavedCharTableForModeView] = useState<
    TableDataCharacteristic[]
  >([]);

  const toggleCollapse = () => {
    setIsCollapseOpen((prev) => {
      if (!fromDateCharacteristic) {
        message.destroy();
        message.warning(messageWarningNotFromDate || "Необходимо выбрать дату создания");
        return false;
      }
      return !prev;
    });
  };

  // Сброс состояния при размонтировании
  useEffect(() => {
    return () => {
      dispatch(characteristicsActions.setPrevFromDate(undefined));
      dispatch(
        characteristicsActions.setIsUpdateParams({
          isDisabled: false,
          isClearTable: false,
        })
      );
    };
  }, []);

  return (
    <CharacteristicsContext.Provider value={contextValue}>
      <div
        className={`сharacteristics-container ${
          isChildCharacteristic ? "child-characteristic" : ""
        }`}
        style={{ width: "100%" }}
      >
        {isChildCharacteristic ? null : <Divider style={{ margin: 0 }} />}
        <Collapse
          activeKey={isCollapseOpen ? ["1"] : []}
          bordered={false}
          onChange={toggleCollapse}
          expandIcon={() =>
            charIcoNotVisible ? null : (
              <>{isCollapseOpen ? <CharacteristicIconOpen /> : <CharacteristicIconClose />}</>
            )
          }
        >
          <Collapse.Panel
            key="1"
            className={isChildCharacteristic ? "isChildCharacteristic-header" : ""}
            header={
              <>
                {isChildCharacteristic ? null : (
                  <Row justify="space-between" className="сharacteristics-container__pageTitle">
                    <h3>{title}</h3>
                  </Row>
                )}
              </>
            }
            forceRender
          >
            <CharacteristicsTable
              mode={mode}
              isInheritableObject={isInheritableObject}
              isSelectedObjectId={isSelectedObjectId}
              objectTypeId={objectTypeId}
              tableData={mode === "view" ? savedCharTableForModeView : tableData}
              setTableData={mode === "view" ? setSavedCharTableForModeView : setTableData}
              dataSaved={dataSaved}
              valuesTitle={valuesTitle}
              setIsCollapseOpen={setIsCollapseOpen}
              newObjectChars={newObjectChars}
              isNewObjectChars={isNewObjectChars}
              isDefaultDisabled={isDefaultDisabled}
              disabledValidation={disabledValidation}
              fieldsError={fieldsError}
              isChildCharacteristic={isChildCharacteristic}
              fromDateCharacteristic={fromDateCharacteristic}
              isUpdateParams={isUpdateParams}
            />
          </Collapse.Panel>
        </Collapse>
      </div>
    </CharacteristicsContext.Provider>
  );
};
